import { render } from "./FacadeOptions.vue?vue&type=template&id=4a23cd5a&scoped=true&ts=true&lang=pug"
import script from "./FacadeOptions.vue?vue&type=script&lang=ts&setup=true"
export * from "./FacadeOptions.vue?vue&type=script&lang=ts&setup=true"

import "./FacadeOptions.vue?vue&type=style&index=0&id=4a23cd5a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a23cd5a"]])

export default __exports__